import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { getDescription } from 'helpers/content';
import { getSMS, updateSMS, deleteSMS } from 'actions/sms';
import { setPageTitle } from 'actions/header';
import { Block, Button, Icon, Table, translate } from '@haldor/ui';
import { Spinner } from 'UI';
import Modal from 'containers/Modals/Modal';
import SMSForm from 'containers/Forms/SMS';
import DateTime from '_class/DateTime';
import PostContent from 'components/Presentation/PostContent';

var SingleSMS = /*#__PURE__*/function (_Component) {
  _inherits(SingleSMS, _Component);

  var _super = _createSuper(SingleSMS);

  function SingleSMS(props) {
    var _this;

    _classCallCheck(this, SingleSMS);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.props.setPageTitle('Sms');

              _context.next = 3;
              return _this.props.getSMS(_this.props.match.params.id);

            case 3:
              _this.setState({
                loading: false
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onUpdate", function (values) {
      return new Promise(function (resolve, reject) {
        _this.props.updateSMS(values).then(function () {
          resolve(1);

          _this.setState({
            editForm: false
          });
        })["catch"](function () {
          reject(_this.props.translate('Something went wrong, try again'));
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.setState({
                removing: true
              });

            case 2:
              swal.fire({
                title: _this.props.translate('Remove'),
                text: _this.props.translate('Are you sure you want to delete this sms?'),
                showCancelButton: true,
                focusConfirm: false,
                cancelButtonText: _this.props.translate('No'),
                confirmButtonText: _this.props.translate('Yes')
              }).then(function (result) {
                if (result.value != null) {
                  _this.props.deleteSMS(_this.props.sms.id).then(function () {
                    _this.props.history.push('/sms');
                  });
                } else {
                  _this.setState({
                    removing: false
                  });
                }
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _this.state = {
      editForm: false,
      loading: true,
      removing: false
    };
    return _this;
  }

  _createClass(SingleSMS, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.sms == null || this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var sms = this.props.sms;
      var relationships = sms.relationships;

      if (relationships != null) {
        relationships = _toConsumableArray(relationships).filter(function (relation) {
          return relation.referenceType != 'SECTION';
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-task sms"
      }, sms.status == 'SMS_DRAFT' ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.editForm,
        title: this.props.translate('Edit sms'),
        onClose: function onClose() {
          return _this2.setState({
            editForm: false
          });
        }
      }, /*#__PURE__*/React.createElement(SMSForm, {
        initialValues: this.props.sms,
        onSubmit: this.onUpdate,
        onCancel: function onCancel() {
          return _this2.setState({
            editForm: false
          });
        }
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-section left-side"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('Message')), sms.title != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: 500
        }
      }, sms.title) : null, /*#__PURE__*/React.createElement(PostContent, null, getDescription(sms.message.replace(/\n/g, '<br />'))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('Created by')), sms.createdUser.firstName, " ", sms.createdUser.lastName), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('Status')), this.props.translate(sms.status)))), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate("tools")), sms.status == 'SMS_DRAFT' ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this2.setState({
            editForm: true
          });
        },
        disabled: this.state.removing
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), this.props.translate('Edit')) : null, sms.status == 'SMS_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: this.state.removing,
        onClick: this.onRemove
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), this.props.translate('Remove'), this.state.removing ? /*#__PURE__*/React.createElement(Spinner, null) : null)) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('Recipients')), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0 -1.7rem',
          marginTop: '1.5rem'
        }
      }, relationships != null && relationships.length > 0 ? /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, this.props.translate('Name')), /*#__PURE__*/React.createElement("th", null, this.props.translate('Phone number')), /*#__PURE__*/React.createElement("th", null, this.props.translate('Status')), /*#__PURE__*/React.createElement("th", null, this.props.translate('Delivered')))), /*#__PURE__*/React.createElement("tbody", null, relationships.map(function (relationship) {
        return /*#__PURE__*/React.createElement("tr", {
          key: relationship.id
        }, /*#__PURE__*/React.createElement("td", null, relationship.user.firstName != null ? relationship.user.firstName + ' ' : '', relationship.user.lastName != null ? relationship.user.lastName : ''), /*#__PURE__*/React.createElement("td", null, relationship.mobilePhone != null ? relationship.mobilePhone : _this2.props.translate('Phone number missing')), /*#__PURE__*/React.createElement("td", null, _this2.props.translate(relationship.status)), /*#__PURE__*/React.createElement("td", null, relationship.deliveredDate != null ? new DateTime(relationship.deliveredDate).getTimeStampHours() : null));
      }))) : null)));
    }
  }]);

  return SingleSMS;
}(Component);

function mapStateToProps(state) {
  return {
    sms: state.SMS.single,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getSMS: getSMS,
  updateSMS: updateSMS,
  deleteSMS: deleteSMS,
  setPageTitle: setPageTitle
})(SingleSMS);